export * from './ProductDetailsDressingDetailsView';
